<script>
import BannerInfo from '@/components/infos/BannerInfo'
import TopBar from '@/components/top/TopBar'
import PixelEditor from '@/model/pixel/PixelEditor'
import { mapActions, mapGetters } from 'vuex'

// ----------------- MENU
import DefaultMenu from '@/components/menu/DefaultMenu'

import FormatMenu from '@/components/menu/format/FormatMenu'
import PersonnalFormat from '@/components/menu/format/PersonnalFormat'

import CalquesMenu from '@/components/menu/CalquesMenu'
import FiltresMenu from '@/components/menu/FiltresMenu'

import AjustementsMenu from '@/components/menu/AjustementsMenu'
import LuminositeMenu from '@/components/menu/ajustement/LuminositeMenu'

import FormesMenu from '@/components/menu/FormesMenu'
import TextMenu from '@/components/menu/TextMenu'

import EmojiModal from '@/components/modal/EmojiModal'
import ImageModal from '@/components/modal/ImageModal'
import KeyBoardManager from '@/model/pixel/elements/KeyBoardManager'

import TemplatesMenu from '@/components/menu/TemplatesMenu'
import CreateTemplateMenu from '@/components/menu/template/CreateTemplateMenu'
import TemplateInfo from '@/components/menu/template/TemplateInfo'
import TemplateDeleteModal from '@/components/modal/TemplateDeleteModal'
import TemplateLoadModal from '@/components/modal/TemplateLoadModal'
import TemplateSaveModal from '@/components/modal/TemplateSaveModal'

import CloseModal from '@/components/modal/CloseModal'
import PaymentModal from '@/components/modal/PaymentModal'

import {
  EventBus,
  PAYMENT_INFO,
  TEMPLATE_DELETING,
  TEMPLATE_LOADING,
  TEMPLATE_MODIFIED
} from '@/model/EventBus'

import { defined, getLast, gt } from 'junctions-fp'
import HttpConnector from './model/http/HttpConnector'

import { closePixel, pixelReady } from '@/model/PixelIOGateway'

export default {
  name: 'app',

  components: {
    ImageModal,
    EmojiModal,
    TopBar,
    BannerInfo,
    DefaultMenu,
    FormatMenu,
    PersonnalFormat,
    CalquesMenu,
    TemplatesMenu,
    FiltresMenu,
    AjustementsMenu,
    LuminositeMenu,
    TextMenu,
    FormesMenu,
    TemplateInfo,
    CreateTemplateMenu,
    TemplateSaveModal,
    TemplateLoadModal,
    TemplateDeleteModal,
    PaymentModal,
    CloseModal
  },

  data() {
    return {
      historyMenu: ['DefaultMenu'],
      imageModalOpen: false,
      emojiModalOpen: false,
      pixelEditor: null,
      openStartModal: true,
      openExportModal: false,
      openLoadingModal: false,
      templateLoading: false,
      templateDeleteting: false,
      template: null,
      showPayment: false,
      loadingModalLabel: 'Chargement en cours...',
      uploadFilesLength: 1,
      currentUploadedFiles: 0,
      currentFormat: null,
      zoomFactor: 50,
      showLoader: false,
      showSaveModal: false,
      formatList: [],
      closeModalOpen: false,
      editorSize: {
        maxHeight: '0px',
        textAlign: 'center'
      }
    }
  },

  computed: {
    ...mapGetters([
      'getFormatButtons',
      'getCurrentFormat',
      'getCurrentColor',
      'getFontFormat',
      'templatesList',
      'getLimitations',
      'getFontsList',
      'getEditorMaxSize',
      'getDomain'
    ]),

    currentMenu() {
      return getLast(this.historyMenu)
    }
  },

  created() {
    const uri = new URL(window.location.href)
    const token = uri.searchParams.get('t')

    if (token) {
      HttpConnector.getInstance(token)
    } else {
      const domain = uri.searchParams.get('d')

      if (domain && domain.trim() === '*') {
        throw new Error('domain error')
      }

      this.updateDomain(domain)
    }

    window.addEventListener('message', async event => {
      const message = event.data

      if (!message) {
        return
      }

      if (message.event === 'init' && message.emitter === 'pixelio') {
        if (message.image) {
          this.pixelEditor.loadImage(message.image)
        }

        if (!token) {
          HttpConnector.getInstance(message.token)

          await this.getUserInfo()
          await this.loadFonts()

          if (uri.searchParams.get('d') !== this.getDomain) {
            console.error(
              `domain in url param ${uri.searchParams.get('d')} not same url in plan ${this.getDomain}`
            )
          }
        }

        if (defined(message.size)) {
          this.pixelEditor.changeFormat(
            message.size.width,
            message.size.height
          )

          const format = {
            format: 'publication',
            width: message.size.width,
            height: message.size.height,
            network: 'personnal',
            font: 'fa',
            icon: 'user',
            label: 'personnal'
          }

          this.updateRestrictedSize(message.size.restrict || false)
          this.updateCurrentFormat(format)
        }

        this.updateOpenedMode(message.openedMode)
        this.updateSaveLocal(message.canSaveLocal)
        this.updateUpgradeEvent(message.upgradeEvent)
        this.updateCloseButton(message.closeButton)
        this.updateSaveMenuList(message.saveMenuList)
      }
    })

    this.pixelEditor = new PixelEditor()

    this.pixelEditor.on(
      'imageLoaded',
      () => EventBus.$emit(TEMPLATE_MODIFIED)
    )

    this.pixelEditor.on(
      'zoomUpadted',
      zoomValue => {
        this.zoomFactor = Math.floor(zoomValue * 100)
      }
    )

    this.pixelEditor.on(
      'removeItem',
      () => EventBus.$emit(TEMPLATE_MODIFIED)
    )

    this.pixelEditor.on(
      'modified',
      () => EventBus.$emit(TEMPLATE_MODIFIED)
    )

    this.pixelEditor.on(
      'loadedTemplate',
      () => {
        this.templateLoading = false
      }
    )

    this.pixelEditor.on(
      KeyBoardManager.EVENT_CREATE_TEXTBOX,
      () => this.createText()
    )

    this.pixelEditor.on(
      KeyBoardManager.EVENT_SHOW_FILTER,
      () => this.onSelectFilter()
    )

    this.pixelEditor.on(
      KeyBoardManager.EVENT_SHOW_IMAGE,
      () => this.openImage()
    )

    this.pixelEditor.on(
      KeyBoardManager.EVENT_SHOW_ADJUSTEMENT,
      () => this.nextMenu('AjustementsMenu')
    )

    this.pixelEditor.on(
      KeyBoardManager.EVENT_SHOW_SHAPE,
      () => this.nextMenu('FormesMenu')
    )

    this.pixelEditor.on(
      KeyBoardManager.EVENT_SHOW_TEMPLATE,
      () => this.nextMenu('TemplatesMenu')
    )

    this.pixelEditor.on(
      KeyBoardManager.EVENT_SHOW_LAYER,
      () => this.nextMenu('CalquesMenu')
    )

    EventBus.$on(
      TEMPLATE_LOADING,
      () => {
        this.templateLoading = true
      }
    )

    EventBus.$on(
      TEMPLATE_DELETING,
      template => {
        this.template = template
        this.templateDeleteting = true
      }
    )
  },

  async mounted() {
    console.log(
      '%c🪻 Swello Pixel v1.6.2.b 🪻',
      'font-size:1rem;color:#9B3196;'
    )

    this.pixelEditor.setContainer(
      this.$refs.container,
      this.getEditorMaxSize.maxWidth,
      this.getEditorMaxSize.maxHeight
    )

    this.resizeEditor()

    window.addEventListener('resize', this.resizeEditor)

    try {
      const uri = new URL(window.location.href)

      if (uri.searchParams.get('t')) {
        await this.getUserInfo()
        await this.loadFonts()
      }

      pixelReady(this.getDomain)
    } catch (error) {
      console.error('Erreur pendant l’initialisation de Pixel', error)
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEditor)
  },

  methods: {
    ...mapActions([
      'getTemplate',
      'saveTemplate',
      'deleteTemplate',
      'updateTemplate',
      'getUserInfo',
      'updateCurrentFormat',
      'updateSaveLocal',
      'updateOpenedMode',
      'updateRestrictedSize',
      'updateUpgradeEvent',
      'updateDomain',
      'updateCloseButton',
      'updateSaveMenuList'
    ]),

    /**
     * Charge toutes les polices provenant de getFontsList.
     *
     * Les fichiers CSS sont d'abord injectés dans le document.
     * Ensuite, chaque font-family est chargée avec document.fonts.
     */
    async loadFonts() {
      const fonts = this.getFontsList || []

      if (fonts.length === 0) {
        console.warn('Aucune police à charger')
        return
      }

      const customFonts = fonts.filter(font => {
        return (
          font.type === 'custom' &&
          font.cssUrl &&
          (font.fontFamily || font.label)
        )
      })

      const googleFonts = fonts.filter(font => {
        return (
          font.type === 'google' &&
          font.cssUrl
        )
      })

      const customCssUrls = [
        ...new Set(
          customFonts.map(font => font.cssUrl)
        )
      ]

      const googleCssUrls = [
        ...new Set(
          googleFonts.map(font => this.getGoogleFontStylesheetUrl(font.cssUrl))
        )
      ]

      const stylesheetUrls = [
        ...customCssUrls,
        ...googleCssUrls
      ]


      await Promise.all(
        stylesheetUrls.map(cssUrl => {
          return this.loadFontStylesheet(cssUrl)
        })
      )

      const families = [
        ...new Set(
          fonts
            .map(font => font.fontFamily || font.label)
            .filter(Boolean)
        )
      ]


      /*
       * Promise.allSettled n'est pas utilisé, car il n'est pas disponible
       * dans la version de Promise/core-js utilisée par le projet.
       */
      const results = await Promise.all(
        families.map(fontFamily => {
          return this.loadFontFamily(fontFamily)
            .then(() => {
              return {
                status: 'fulfilled',
                fontFamily
              }
            })
            .catch(error => {
              return {
                status: 'rejected',
                fontFamily,
                error
              }
            })
        })
      )

      const failedFonts = []

      results.forEach(result => {
        if (result.status === 'fulfilled') {
          return
        }

        failedFonts.push(result)
      })

      await document.fonts.ready



    },

    /**
     * Transforme une valeur de police Google en URL CSS.
     *
     * Accepte :
     * - une URL complète ;
     * - "Roboto:400,700" ;
     * - "Open Sans".
     */
     getGoogleFontStylesheetUrl(value) {
       if (/^https?:\/\//i.test(value)) {
         return value
       }

       const normalizedFamily = value
         .replace(/\+/g, ' ')
         .trim()
         .split(/\s+/)
         .join('+')

       return `https://fonts.googleapis.com/css?family=${normalizedFamily}`
     },

    /**
     * Résout correctement l'URL du CSS.
     *
     * "./static/fonts/..." devient :
     * "https://domaine.tld/static/fonts/..."
     *
     * Cela évite que le chemin dépende de la route actuelle de la SPA.
     */
    resolveFontStylesheetUrl(cssUrl) {
      if (/^https?:\/\//i.test(cssUrl)) {
        return cssUrl
      }

      const normalizedUrl = cssUrl.replace(/^\.?\//, '')

      return new URL(
        `/${normalizedUrl}`,
        window.location.origin
      ).href
    },

    /**
     * Injecte une balise <link rel="stylesheet">.
     */
    loadFontStylesheet(cssUrl) {
      return new Promise((resolve, reject) => {
        const absoluteUrl = this.resolveFontStylesheetUrl(cssUrl)

        const existingLink = Array.prototype.slice
          .call(document.querySelectorAll('link[rel="stylesheet"]'))
          .find(link => link.href === absoluteUrl)

        if (existingLink) {
          if (
            existingLink.dataset &&
            existingLink.dataset.fontStylesheetLoaded === 'true'
          ) {
            resolve(absoluteUrl)
            return
          }

          /*
           * Si la feuille est déjà présente, elle a généralement déjà
           * été chargée. On vérifie sa présence dans document.styleSheets.
           */
          const stylesheetAlreadyLoaded = Array.prototype.slice
            .call(document.styleSheets)
            .some(stylesheet => stylesheet.href === absoluteUrl)

          if (stylesheetAlreadyLoaded) {
            if (existingLink.dataset) {
              existingLink.dataset.fontStylesheetLoaded = 'true'
            }

            resolve(absoluteUrl)
            return
          }

          existingLink.addEventListener(
            'load',
            () => {
              if (existingLink.dataset) {
                existingLink.dataset.fontStylesheetLoaded = 'true'
              }

              resolve(absoluteUrl)
            },
            { once: true }
          )

          existingLink.addEventListener(
            'error',
            () => {
              reject(
                new Error(
                  `Impossible de charger le CSS de police : ${absoluteUrl}`
                )
              )
            },
            { once: true }
          )

          return
        }

        const link = document.createElement('link')

        link.rel = 'stylesheet'
        link.type = 'text/css'
        link.href = absoluteUrl

        link.onload = () => {
          if (link.dataset) {
            link.dataset.fontStylesheetLoaded = 'true'
          }


          resolve(absoluteUrl)
        }

        link.onerror = () => {
          reject(
            new Error(
              `Impossible de charger le CSS de police : ${absoluteUrl}`
            )
          )
        }

        document.head.appendChild(link)
      })
    },

    /**
     * Charge une font-family avec l'API native CSS Font Loading.
     *
     * Toutes les familles séparées du CSS Marianne doivent idéalement
     * être déclarées avec :
     *
     * font-weight: 400;
     * font-style: normal;
     */
    async loadFontFamily(fontFamily) {
      if (!document.fonts || !document.fonts.load) {

        return
      }

      const declaration = `400 16px "${fontFamily}"`
      const testText = 'Dragon Paladin Marianne'

      const loadedFonts = await document.fonts.load(
        declaration,
        testText
      )

      if (!loadedFonts || loadedFonts.length === 0) {
        throw new Error(
          `Aucun fichier de police trouvé pour "${fontFamily}"`
        )
      }

      const isAvailable = document.fonts.check(
        declaration,
        testText
      )

      if (!isAvailable) {
        throw new Error(
          `La famille "${fontFamily}" n’est pas disponible`
        )
      }
    },

    /////////////////////////////////////////////////////////////////////////
    // MENU
    /////////////////////////////////////////////////////////////////////////

    nextMenu(menu) {
      if (getLast(this.historyMenu) !== menu) {
        this.historyMenu = [
          ...this.historyMenu,
          menu
        ]
      }
    },

    backMenu() {
      this.historyMenu.splice(-1, 1)
    },

    /////////////////////////////////////////////////////////////////////////
    // SHORTCUT HANDLER
    /////////////////////////////////////////////////////////////////////////

    openImage() {
      this.imageModalOpen = true
    },

    openEmoji() {
      this.emojiModalOpen = true
    },

    createText() {
      this.pixelEditor.insertText({
        width: 200,
        fill: '#000',
        lineHeight: 1.16,
        ...this.getFontFormat
      })

      this.nextMenu('TextMenu')
      EventBus.$emit(TEMPLATE_MODIFIED)
    },

    onSelectFilter() {
      this.nextMenu('FiltresMenu')
    },

    createTemplateHandler() {
      this.nextMenu('CreateTemplateMenu')
    },

    /////////////////////////////////////////////////////////////////////////
    // GLOBAL
    /////////////////////////////////////////////////////////////////////////

    resizeEditor() {
      const maxHeight = this.$refs.menu
        ? window.innerHeight - this.$refs.menu.scrollHeight
        : 0

      this.editorSize = {
        height: `${maxHeight}px`
      }
    },

    loadedTemplate() {
      // Méthode conservée pour compatibilité.
    },

    /////////////////////////////////////////////////////////////////////////
    // DRAG AND DROP
    /////////////////////////////////////////////////////////////////////////

    onFileUpload(image) {
      this.pixelEditor.loadImage(image)
    },

    drop_handler(event) {
      if (event.type !== 'drop') {
        return
      }

      const dataTransfer = event.dataTransfer

      if (!dataTransfer || !dataTransfer.items) {
        return
      }

      const items = [...dataTransfer.items]

      if (
        this.getLimitations.maxImages !== -1 &&
        gt(
          this.getLimitations.maxImages,
          this.pixelEditor.getImagesCount() + items.length
        )
      ) {
        EventBus.$emit(PAYMENT_INFO, {
          type: 'infos',
          code: 'paymentContent',
          class: 'danger'
        })

        return
      }

      items.forEach(item => {
        const file = item.getAsFile()

        if (file) {
          this.onFileUpload(file)
        }
      })

      EventBus.$emit(TEMPLATE_MODIFIED)
    },

    handler() {
      // Méthode conservée pour compatibilité.
    },

    sendClosePixel() {
      this.closeModalOpen = false
      closePixel(this.getDomain)
    }
  },

  watch: {}
}
</script>

<template>
  <sw-application id="app">
    <top-bar
      :editor="pixelEditor"
      @closePixel="closeModalOpen = true"
    />

    <div class="application__content flex center">
      <div
        ref="container"
        class="flex center"
        @drop.prevent.stop="drop_handler"
        @dragover.prevent.stop="drop_handler"
      ></div>
    </div>

    <div
      ref="menu"
      class="application__menu flex center"
    >
      <div class="menu-wrapper flex center">
        <transition
          name="fade"
          mode="out-in"
        >
          <component
            :is="currentMenu"
            :editor="pixelEditor"
            @changeMenu="nextMenu"
            @backMenu="backMenu"
            @openImage="openImage"
            @openEmoji="openEmoji"
          />
        </transition>
      </div>
    </div>

    <image-modal
      :open="imageModalOpen"
      :editor="pixelEditor"
      @close="imageModalOpen = false"
    />

    <emoji-modal
      :open="emojiModalOpen"
      :editor="pixelEditor"
      @close="emojiModalOpen = false"
    />

    <template-info
      @createTemplate="createTemplateHandler"
    />

    <template-save-modal
      :editor="pixelEditor"
      @changeMenu="nextMenu"
    />

    <template-load-modal
      :open="templateLoading"
      @changeMenu="nextMenu"
    />

    <template-delete-modal
      :open="templateDeleteting"
      :template="template"
      @close="templateDeleteting = false"
    />

    <payment-modal />

    <close-modal
      :open="closeModalOpen"
      @close="closeModalOpen = false"
      @closePixel="sendClosePixel"
    />

    <banner-info />
  </sw-application>
</template>



// WEBPACK FOOTER //
// src/App.vue